import { Box, Grid, Typography } from "@mui/material";
import { GadgetIcon } from "../../Home/components/gadgets/GadgetIcon";
import { FlattenedGadget } from "../../../models/GadgetModel";
import styles from "../css/BriefGadgetInfo.module.css";
import { PlatformIcon } from "../../Home/components/gadgets/GadgetPlaform";
import { getGadgetSizeInMB } from "../../../helper/utils";
import { InstallOnAllDevicesButton } from "./InstallOnAllDevicesButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { useAppSelector } from "../../../common/state/hooks";
import { RootState } from "../../../common/state";
import { useEffect, useState } from "react";

interface BriefGadgetDetailsProps {
  displayGadget: FlattenedGadget;
}

export const BriefGadgetInfo = ({ displayGadget }: BriefGadgetDetailsProps) => {
  const connectedDeviceList = useAppSelector(
    (state: RootState) => state.connectedDeviceSlice.deviceList
  );
  const allDeviceData = useAppSelector(
    (state: RootState) => state.installOnAllDeviceSlice.status
  );
  const isAnyDeviceOnline = connectedDeviceList.filter((it) => it.online).length > 0;
  const gadgetSize = getGadgetSizeInMB(displayGadget.size);
  const [isInstallationFinish, setIsInstallationFinish] =
    useState<boolean>(false);
  const [successfullGadgetInstallationNo, setSuccessfullGadgetInstallationNo] =
    useState<number>(0);
  const [failedGadgetInstallationNo, setFailedGadgetInstallationNo] =
    useState<number>(0);

  useEffect(() => {
    if (allDeviceData && displayGadget.id in allDeviceData) {
      const gadgetData = allDeviceData[displayGadget.id];
      const currentRemainingDevices = gadgetData.remainingDevices;
      setIsInstallationFinish(
        currentRemainingDevices && currentRemainingDevices.length === 0
      );
      setSuccessfullGadgetInstallationNo(
        gadgetData.successfullGadgetInstallationNo
      );
      setFailedGadgetInstallationNo(gadgetData.failedGadgetInstallationNo);
    }
  }, [allDeviceData, displayGadget.id]);

  return (
    <Grid container className={styles.gridContainer}>
      <Grid item xs={8}>
        <Box className={styles.container}>
          <Box className={styles.iconContainer}>
            <GadgetIcon
              image={displayGadget.icon}
              altText="Gadget icon"
              styles={{ borderRadius: 5 }}
              dataTestId="gadget-icon"
            />
          </Box>
          <Box className={styles.textContainer}>
            <Typography variant="h2" className={styles.nameText} data-testid="gadget-name">
              {displayGadget.name}
            </Typography>
            <Typography variant="body2" className={styles.providerText} data-testid="gadget-developer">
              {displayGadget.developer_name}
            </Typography>
            <div className={styles.iconSizeContainer}>
              <PlatformIcon
                platform={displayGadget.platform}
                size="2xl"
                style={{ color: "#44bcdb" }}
              />
              <Typography variant="body2" className={styles.sizeText} data-testid="gadget-size">
                {"Size : "}
                <span className={styles.valueText}>{`${gadgetSize}MB`}</span>
              </Typography>
            </div>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={4} className={styles.installAllButtonContainer}>
        <InstallOnAllDevicesButton displayGadget={displayGadget} />
        <Box
          data-testid={"all-install-status-container"}
          sx={{
            display:
              isInstallationFinish && isAnyDeviceOnline ? "flex" : "none",
          }}
          className={styles.statusContainer}
        >
          <Typography
            variant="subtitle2"
            className={styles.successStatusText}
            data-testid={"installation-status-success"}
          >
            <FontAwesomeIcon icon={faCircleCheck} size="sm" />
            {"Success: "}
            <span
              className={styles.deviceNoText}
            >{`${successfullGadgetInstallationNo} device`}</span>
          </Typography>
          <Typography
            variant="subtitle2"
            className={styles.errorStatusText}
            data-testid={"installation-status-failure"}
          >
            <FontAwesomeIcon icon={faCircleExclamation} size="sm" />
            {"Failure: "}
            <span
              className={styles.deviceNoText}
            >{`${failedGadgetInstallationNo} device`}</span>
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};
